import $ from 'jquery'
import { animateFade } from '../_variables'

export default class ouchiBeauty {
  init() {
    $(function () {
      if($('.js-fade-beauty').length > 0) {
        $('.js-fade-beauty .logo').addClass('fade-in');

        setTimeout(function(){ 
          $('.js-fade-beauty .image').addClass('fade-in');
        }, 1000);
      }
    })
  }
}
